import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93b4969c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-field" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Задачи на сегодня", -1))
const _hoisted_3 = { class: "form-input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "submit-btn"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Подтвердить")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.handleAddTodo($setup.contentRef)), ["prevent"])),
      class: "form-wrapper"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          ref: "inputRef",
          placeholder: "Добавить задачу...",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.contentRef) = $event)),
          autofocus: ""
        }, null, 512), [
          [
            _vModelText,
            $setup.contentRef,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _hoisted_4
    ], 32)
  ]))
}